import React, {useEffect, useState} from "react";
import "./RiskScoreCard.css";

function getRandomFactors(factors, count = 5) {
    const shuffled = factors.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
}

export default function RiskScoreCard({address, state}) {
    const [loading, setLoading] = useState(true);
    // const [data, setData] = useState(null);
    const [showData, setShowData] = useState(false);

    const statusMessages = {
        connect: "Подключение кошелька...",
        connected: "Кошелек подключен. Получение данных...",
        waitingAcceptTransaction: "Ожидание подтверждения доступа к истории...",
        validating: "Анализ данных. Нужно немного подождать...",
        waitingReport: "Анализ завершен...",
        generateReport: "Генерация отчета...",
        report: "Отчет готов",
        cancel: "Отменено пользователем, повторный запрос"
    };
    // setData(generateMockData());

    /*    useEffect(() => {
            setTimeout(() => {

                setLoading(false);
                setTimeout(() => setShowData(true), 100);
            }, 2000);
        }, []);*/

    if (state !== 'report') {
        // return <div className="spinner"></div>;
        return (
            <>
                <div className="loading-overlay">
                    <div className="circle" />
                    <div className="circle" />
                    <div className="circle" />
                </div>
                <div className="loading-window fade-in">
                    <div className="spinner"/>
                    <p className="status-text">{statusMessages[state]}</p>
                </div>
            </>
        )
    }


    const data = {
        date: new Date().toLocaleDateString(),
        eth: (Math.random() * 0.5).toFixed(3),
        address: address,
        darkMarket: {
            percentage: (Math.random() * 2).toFixed(1),
            value: (Math.random() * 100).toFixed(2),
        },
        exchange: {
            percentage: (Math.random() * 80 + 10).toFixed(1),
            value: (Math.random() * 5000 + 100).toFixed(2),
        },
        transactions: Array.from({length: 5}).map(() => ({
            address: "0x" + Math.random().toString(16).substring(2, 6) + "...Acb7",
            risky: Math.random() > 0.6,
        })),
        factors: [
            // 🛑 Опасные источники (Danger)
            // { name: "Child Exploitation", impact: Math.random() * 30 },
            // { name: "Dark Market", impact: Math.random() * 30 },
            // { name: "Dark Service", impact: Math.random() * 30 },
            // { name: "Enforcement Action", impact: Math.random() * 30 },
            // { name: "Fraudulent Exchange", impact: Math.random() * 30 },
            // { name: "Gambling", impact: Math.random() * 30 },
            // { name: "Illegal Service", impact: Math.random() * 30 },
            // { name: "Mixer", impact: Math.random() * 30 },
            // { name: "Ransom", impact: Math.random() * 30 },
            // { name: "Sanctions", impact: Math.random() * 30 },
            // { name: "Scam", impact: Math.random() * 30 },
            // { name: "Stolen Coins", impact: Math.random() * 30 },
            // { name: "Terrorism Financing", impact: Math.random() * 30 },

            // ⚠️ Подозрительные источники (Suspicious Sources)
            { name: "ATM", impact: Math.random() * 30 },
            { name: "Exchange | High Risk", impact: Math.random() * 30 },
            { name: "Liquidity Pools", impact: Math.random() * 30 },
            { name: "P2P Exchange | High Risk", impact: Math.random() * 30 },
            { name: "Unnamed Service", impact: Math.random() * 30 },

            // ✅ Надежные источники (Trusted Sources)
            { name: "Exchange", impact: Math.random() * 50 },
            { name: "ICO", impact: Math.random() * 20 },
            { name: "Marketplace", impact: Math.random() * 20 },
            { name: "Merchant Services", impact: Math.random() * 40 },
            { name: "Miner", impact: Math.random() * 10 },
            { name: "Other", impact: Math.random() * 20 },
            { name: "P2P Exchange", impact: Math.random() * 30 },
            { name: "Payment Processor", impact: Math.random() * 50 },
            { name: "Seized Assets", impact: Math.random() * 40 },
            { name: "Wallet", impact: Math.random() * 30 },
        ],

    }

    const randomFactors = getRandomFactors(data.factors);

    const riskLevel = data.darkMarket.percentage > 4 ? "Danger" : "Trusted";
    const indicatorPosition = riskLevel === "Danger" ? "10%" : `${parseFloat(Math.random() * 40 + 45)}%`;
    setTimeout(() => setShowData(true), 200);

    return (
        <div className="report-container">
            <div className="watermark"/>
            {/* Весь остальной контент отчета */}
            <div className="wallet-info">
                <div className={`risk-card ${showData ? "visible" : ""}`}>
                    <h2>Risk Report</h2>
                    <div className="wallet-info">
                        <img
                            src={`assets/img/tron.png`}
                            alt={data.network}
                            style={{
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle",
                                marginRight: "6px",
                                marginTop: "5px"
                            }}
                        />
                    </div>

                    <div className="wallet-info">
                        <span className="address">{data.address}</span>
                    </div>

                    <div className="scale">
                        <span>Bad</span>
                        <div className="bar">
                            <div
                                className="indicator"
                                style={{left: indicatorPosition, background: riskLevel === "Danger" ? "red" : "green"}}
                            ></div>
                        </div>
                        <span>Good</span>
                    </div>

                    <div className={`risk-status ${riskLevel.toLowerCase()}`}>
                        <strong>{riskLevel === "Danger" ? "🚫 Danger" : "✅ Trusted"}</strong>
                    </div>

                    <div className="risk-text">
                        <h4>{riskLevel === "Danger" ? "High risk of blocking" : "Low risk"}</h4>
                        <p>
                            {riskLevel === "Danger"
                                ? "Transfers from this wallet might be blocked on centralized cryptoexchanges (like Binance, Huobi, etc)."
                                : "This wallet is considered safe for transfers."}
                        </p>

                    </div>

                    <div className="source-row">
                        <div className="source red">
                            <span>{data.darkMarket.percentage}%</span>
                            <strong>Dark Market</strong>

                        </div>
                        <div className="source green">
                            <span>{data.exchange.percentage}%</span>
                            <strong>Exchange</strong>

                        </div>
                    </div>

                    {/*<div className="tx-section">*/}
                    {/*    <h4>Related Transactions</h4>*/}
                    {/*    {data.transactions.map((tx, i) => (*/}
                    {/*        <div className="tx-short" key={i}>*/}
                    {/*            <span>{tx.address}</span>*/}
                    {/*            <span className={tx.risky ? "risk-flag danger" : "risk-flag safe"}>*/}
                    {/*                {tx.risky ? "⚠️" : "✅"}*/}
                    {/*            </span>*/}
                    {/*        </div>*/}
                    {/*    ))}*/}
                    {/*</div>*/}

                    <div className="factors">
                        <h4>AML Risk Factors</h4>
                        {randomFactors.map((f, i) => (
                            <div className="factor" key={i}>
                                <div className="factor-label">
                                    <span>{f.name}</span>
                                    <span>{f.impact.toFixed(1)}%</span>
                                </div>
                                <div className="factor-bar">
                                    <div
                                        className="factor-fill"
                                        style={{width: `${f.impact.toFixed(1)}%`}}
                                    ></div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="report-date">Report Date: {data.date}</div>


                </div>
            </div>
        </div>
    );
}


